/**
 * NewsletterSuccessPage Component
 */

import { replaceQueue } from '../../../../redux/actions/player';
import { getPlayerTracksFromResults } from '../../../../redux/helpers/player';
import { EmptyStateFragment } from '../../../../relay/emptyState';
import './styles.scss';

import { RouteMatch } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { createFragmentContainer } from 'react-relay';
import { VelocityTransitionGroup } from 'velocity-react';

import Page from '../../../../containers/Page';
import LinkButton from '../../../atoms/buttons/LinkButton';
import Heading from '../../../atoms/text/Heading';
import BlogPosts from '../../../organisms/content/BlogPosts';
import Charts from '../../../organisms/content/Charts';
import Collections from '../../../organisms/content/Collections';
import FeaturedArtistList from '../../../organisms/content/FeaturedArtists';
import StaffPicks from '../../../organisms/content/StaffPicks';
import { BrowsePagePath } from '../../browse/Browse';

export const NewsletterSuccessPagePath = '/email/reconfirm';

interface IOwnDispatchProps {
  setPlayerQueue: (tracks: IPlayerTrack[]) => void;
}

interface IOwnProps {
  viewer: GQL.IViewer;
  withCarousel?: boolean;
}

type NewsletterSuccessPageProps = IOwnProps & IOwnDispatchProps & RouteMatch;

const classes = new BEM('newsletter-success');
const defaultList = [];

class NewsletterSuccessPage extends React.Component<NewsletterSuccessPageProps, any> {

  componentDidMount() {
    const data = this.props.viewer.home_page!;
    const allTracks = [
      ...(data.featured_artist_tracks || defaultList),
      ...(data.featured_tracks || defaultList),
    ];
    this.props.setPlayerQueue(getPlayerTracksFromResults(allTracks));
  }

  render() {
    const data = this.props.viewer.home_page!;
    const staffPicks = data.featured_tracks || defaultList;
    const featuredArtists = data.featured_artist_tracks || defaultList;
    const featuredCollections = data.featured_collections || defaultList;
    const charts = data.track_charts || defaultList;
    const blogPosts = data.blog_posts || defaultList;

    return (
      <Page id="newsletter-success" layout="loose">
        <Helmet>
          <title>Thanks For Signing Up!</title>
          <meta name="description" content="Helmet application" />
        </Helmet>
        <div className="page__main">
          <div {...classes('message')}>
            <div {...classes('message__content-wrapper')}>
              <VelocityTransitionGroup
                component="div"
                enter={{ animation: 'transition.slideUpIn', stagger: 150 }}
                runOnMount
                {...classes('message__content')}
              >
                <Heading is="h6">Great Stuff!</Heading>
                <Heading is="h2" {...classes('message__title')}>
                  Did you know we’ve redesigned our instant licensing app?
                </Heading>
                <LinkButton
                  to={BrowsePagePath}
                  label="Browse Music"
                  size="xlarge"
                  colorScheme="accent"
                  variant="pill"
                  {...classes('message__cta')}
                />
              </VelocityTransitionGroup>
            </div>
          </div>
          <StaffPicks tracks={staffPicks} withBackground />
          <FeaturedArtistList data={featuredArtists} />
          <BlogPosts data={blogPosts} />
          <Collections data={featuredCollections} />
          <Charts data={charts} />
        </div>
      </Page>
    );
  }
}

const ConnectedNewsletterSuccessPage = connect<{}, IOwnDispatchProps, IOwnProps, IStoreState>(
  null,
  (dispatch) => ({
    setPlayerQueue: (tracks) => {
      dispatch(replaceQueue({ tracks }));
    },
  }),
)(NewsletterSuccessPage);

const RelayNewsletterSuccessPage = createFragmentContainer(
  ConnectedNewsletterSuccessPage,
  EmptyStateFragment,
);

export default RelayNewsletterSuccessPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/newsletter/Success/index.tsx